"use client";
import { HTMLProps } from "react";
import { cn } from "@/utils/helpers";
import styles from "./Loader.module.css";

export interface LoaderProps extends HTMLProps<HTMLElement> {
	loading: boolean;
}

export default function Loader({
	loading = true,
	className
} : LoaderProps) {
	return (
		<div
			className={cn(
				styles.Loader,
				loading ? styles.Loader_loading : null,
				className
			)}
		>
			<div className={styles.LoaderSpinner} />
			<div
				className={styles.LoaderText}
			>
				Loading data...
			</div>
		</div>
	);
}